import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { DocumentDTO, getSimpleIdentifierFromString, ExecutionDivisionDTO, DivisionDTO } from '../../api/plyca-dtos';
import {
  ContractModificationDTO, ContractDTO, ProjectEntityDTO, RegisterContractModificationDTO,
  CompanyDocDTO, SpecialCondTracingReportDTO, ContractSpecialConditionsDTO, KpiRecordDTO,
  ActionResultDTO, ResultTypeDTO, DossierSituation
} from '../../api/plyca-dtos-v2';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UIService } from '../../ui.service';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, mergeMap, switchMap, take, tap } from 'rxjs/operators';
import { Configuration } from '../../conf/app.constants';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpParams } from '@angular/common/http';
import { LongTextEditorComponent, LongTextDTOModal } from '../../components/forms/longTextEditor.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import * as  moment from 'moment';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PropertyService } from '../../properties/property.service';
import { ProfileService } from '../../../services/profile.services';
import { UserService } from '../../user.service';
import { contractModificationTypesComponent } from '../../dossiers/contractModifications/contractModificationTypes.component';
import { DossierActionsListComponent } from '../../dossiers/dossierActions/dossierActionsList.component';
import { ExecutionDivisionEditionComponent } from '../../dossiers/contracts/executioDivision.edition.component';
import { UserPrefsService } from '../../store/user-prefs.service';
import { UserPrefs } from '../../api/UserPrefs-dto';
import { DocumentService } from '../../documents/document.service';
import { AntecedentAYMADComponent } from '../antecedent/antecedentAYMAD.component';

@Component({
  selector: 'contractsAYMAD',
  templateUrl: 'contractsAYMAD.template.html',
  providers: [DialogService]
})
export class ContractsAYMADComponent extends BaseComponent implements OnDestroy, OnInit {
  // showHeader = true;
  dossierId: string;
  divisionId: string;

  // DTOS DE LA PANTALLA
  project: ProjectEntityDTO;
  contractList = [];

  contractLotsEnabled: false;
  contractDocsEnabled: false;
  contractExecutionEnabled: false;
  contractEspecialesEjecucionEnabled: false;
  newname = 'nueva fase';
  actualContract = CompanyDocDTO;
  specialConditionsReports: SpecialCondTracingReportDTO[];
  kpisRecords: KpiRecordDTO[];
  kpisDateList: any[];
  executionPercent: number;
  guaranteePercent: number;
  actionDeleteAvailable: boolean = null;

  // INCIDENCIAS.
  newContractModificationVisible = true;
  newRegisterContractModificationVisible = false;
  contractModificationsEnabled: false;


  collapsedContracts = {};
  selectedContractTabs = {};
  private lastContractSeen: string;
  private lastContractSelectedTab: number;
  private loaded = false;

  private signedContracts: { [division: number]: boolean } = {};
  private signedAwardAcceptances: { [division: number]: boolean } = {};

  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    private elem: ElementRef,
    private headerService: HeaderActionsService,
    private uiService: UIService,
    private route: ActivatedRoute,
    private router: Router,
    public configuration: Configuration,
    private waitService: WaitLoadingService,
    public translate: TranslateService,
    public dialogService: DialogService,
    public propertyService: PropertyService,
    public profileService: ProfileService,
    public userService: UserService,
    private appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    private userPrefsService: UserPrefsService,
    private documentService: DocumentService
  ) {
    super();
    this.waitService.startWaiting();

    let newContractModificationProfiles = appConfig.getValue('newContractModification.profiles');
    let newRegisterContractModificationProfiles = this.appConfig.getValue('newRegisterContractModification.profiles');

    this.newContractModificationVisible = this.userService.hasRoles(newContractModificationProfiles, 'CONTRATACION');
    this.newRegisterContractModificationVisible = this.userService.hasRoles(newRegisterContractModificationProfiles, 'RECO');

    this.subscribe(this.route.params, params => {
      this.dossierId = params['id'];
    });
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_CONTRACTS));
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    this.subscribeObserver(
      // leer parametros y preferencias de usuario
      forkJoin([
        this.route.queryParams.pipe(
          take(1),
          tap(params => {
            this.divisionId = params['divisionId'];
            if (this.divisionId) {
              this.divisionId = this.divisionId + '<>' + this.dossierId;
            }
          })
        ),
        this.userPrefsService.getUserPrefs().pipe(
          take(1),
          tap((userPrefs: UserPrefs) => {
            this.lastContractSeen = userPrefs?.contractsViewPrefs?.lastContractSeen;
            this.lastContractSelectedTab = userPrefs?.contractsViewPrefs?.lastContractSelectedTab;
          })
        )
      ]).pipe(
        // cargar pantalla
        mergeMap(() => this.loadInfoObs())
      ),
      {
        complete: () => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        }
      }
    );
    this.headerService.clearActions();
    this.headerService.setTaskDescription(
      this.elem,
      'Contratos del Expediente',
      'fa-file-contract',
      true
    );
    this.subscribe(this.headerService
      .addAction('General.reload', 'fas fa-sync-alt', 'btn-primary', true),
      () => {
        if (this.dossierId) {
          this.waitService.startWaiting();
          this.loaded = false;
          this.subscribeObserver(this.loadInfoObs(),
            {
              complete: () => this.loaded = true
            });
        }
      }
    );
    this.subscribe(this.headerService
      .addAction(
        'General.back',
        'fas fa-chevron-left fa-lg',
        'btn-outline-secondary',
        true
      ),
      () => {
        this.uiService.routeBack();
      });
  }

  ngOnDestroy() {
    this.headerService.clearActions();
    this.subscribe(this.userPrefsService.getUserPrefs().pipe(
      tap((userPrefs: UserPrefs) => {
        userPrefs.contractsViewPrefs = {
          lastContractSeen: this.lastContractSeen,
          lastContractSelectedTab: this.lastContractSelectedTab
        };
        this.userPrefsService.setUserPrefs(userPrefs);
      })
    ));
    super.ngOnDestroy();
  }


  private updateUserPrefs(contractId: string, tab: number): void {
    if (contractId) {
      this.lastContractSeen = contractId;
    }
    if (tab !== undefined) {
      this.lastContractSelectedTab = tab;
    }
  }

  private loadInfoObs(): Observable<any> {
    // obtener contratos y datos expediente
    return forkJoin([
      // Consultamos el expediente con el flag que nos indica si somos usuario en modo soporte
      this.plycaService.getProcurementProjectContract(this.dossierId, '?expand=expansionSet:ALLOWED_FOR_SUPPORT').pipe(
        tap((result: any) => {
          if (result) {
            this.project = result;
          }
        }),
        catchError((error: any) => {
          console.error(error);
          return throwError(error);
        })
      ),
      this.plycaService.query<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL + '?', { identifier: this.dossierId }).pipe(
        tap((result: any) => {
          if (result && result.content) {
            this.contractList = result.content;
          } else {
            this.contractList = [];
          }
        })
      )
    ]).pipe(
      mergeMap(() => {
        // aplicar preferencias de visibilidad del usuario
        let obsLastContract: Observable<any>;
        if (this.lastContractSeen) {
          const event = {
            collapsed: false
          }
          const contract = this.contractList.find((contractAux: ContractDTO) =>
            contractAux.division.identifier === this.lastContractSeen);
          if (contract) {
            // si el último seleccionado esta entre los disponibles cargar detalle
            this.selectedContractTabs[this.lastContractSeen] = this.lastContractSelectedTab;
            obsLastContract = this.loadOneContractObs(event, contract);
          } else {
            // si el último seleccionado no esta entre los disponibles limpiar variable
            this.lastContractSeen = undefined;
            this.lastContractSelectedTab = 0;
          }
        }
        if (!obsLastContract) {
          obsLastContract = of({});
        }
        return obsLastContract;
      })
    );
  }

  handleChange(e, contract: ContractDTO) {
    const contractId = contract?.division?.identifier;
    this.selectedContractTabs[contractId] = e.index;
    this.updateUserPrefs(contractId, e.index);
  }

  public loadOneContract(event: any, contract: ContractDTO): void {
	this.loaded = false;
    if (!event?.collapsed) {
      this.updateUserPrefs(contract?.division?.identifier, undefined);
    }
    this.subscribe(this.loadOneContractObs(event, contract));
  }

  private loadOneContractObs(event: any, contract: ContractDTO): Observable<any> {
    let obs: Observable<any>;
    const contractId = contract.division.identifier;
    this.collapsedContracts[contractId] = event?.collapsed;
    if ((!event || !event.collapsed) && !contract['loaded']) {
      this.waitService.startWaiting();
      obs = this.plycaService.query<ContractDTO>(
        this.configuration.CONTRACTS_SERVICE_URL + '?',
        {
          identifier: this.dossierId,
          division: getSimpleIdentifierFromString(contract.division.identifier),
          expand: 'expansionSet:WEB_CLIENT'
        }
      ).pipe(
        tap(result => {
          let contractIndex = this.contractList.findIndex(x => x.division.identifier === contract.division.identifier);
          Object.assign(this.contractList[contractIndex], result.content[0]);
          this.contractList[contractIndex]['loaded'] = true;
        }),
        mergeMap(() => this.loadContractInfoObs(contract)),
        catchError((error: any) => {
          console.error(error);
          return of({});
        }),
        finalize(() => {
            this.loaded = true;
            this.waitService.cancelWaiting();
          })
        );
      } else {
        this.loaded = true;
        this.waitService.cancelWaiting();
        obs = of({
        });
      }    return obs;
  }

  updatecontinuationDossierTracing(contract: ContractDTO) {
    this.waitService.startWaiting();
    this.updateUserPrefs(contract?.division?.identifier, 1);
    this.plycaService.patch<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL, contract, 'UPDATE_CONT_DOSSIER_TRACKING')
      .pipe(finalize(() => this.waitService.cancelWaiting()))
      .subscribe(result => {
        this.waitService.cancelWaiting();
      }
        , err => {
          console.log('ERROR ACTIVANDO SEGUIMIENTO EXPEDIENTE DE CONTINUACION DE UN CONTRATO');
        });
  }

  private loadContractInfoObs(contract: ContractDTO): Observable<any> {
    contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = false;
    contract['EXT_DATA_DOCUMENTS_LOADED'] = false;
    contract['EXT_DATA_EXECUTIONPHASES_LOADED'] = false;
    contract['EXT_DATA_SHOW_EXECUTIONPHASES'] = 0;
    // LOTES DEL CONTRATO (TODO: ELIMINAR)

    if (contract.procurementProjectInfo && contract.procurementProjectInfo.apportioned) {
      contract['LOTES'] = contract.contractLots;
    }

    let serViceURL: string;
    let allQueriesObs = new Array<Observable<any>>();
    let obs: Observable<any>;


    if (contract.division && contract.division.project
      && contract.division.project.documentClass.identifier === '00600') {
      // FRCFI
      serViceURL = this.configuration.REGISTER_CONTRACT_MODIFICATIONS_SERVICE_URL;
      obs = this.plycaService
        .query<RegisterContractModificationDTO>(
          serViceURL,
          {
            dossierId: this.dossierId,
            contractDivision: getSimpleIdentifierFromString(
              contract.division.identifier
            )
          }
        ).pipe(
          tap(registerContractModifications => {
            let _registerContractModifications;
            if (registerContractModifications && registerContractModifications.content) {
              console.log(
                'INCIDENCIAS DEL CONTRATO ' +
                contract.identifier +
                ' -> ' +
                registerContractModifications
              );
              _registerContractModifications = registerContractModifications.content;
            } else {
              _registerContractModifications = [];
            }
            let _contractModificationsAux: ContractModificationDTO[] = [];
            _registerContractModifications.forEach((registerContractModification: RegisterContractModificationDTO) => {
              registerContractModification.contractModification.document = registerContractModification.document;
              registerContractModification.contractModification.division = registerContractModification.division;
              _contractModificationsAux.push(registerContractModification.contractModification);
            });
            if (_contractModificationsAux) {
              contract['EXT_DATA_CONTRACTMODIFICATIONS'] = _contractModificationsAux;
              contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = true;
            }
          }),
          catchError((error: any) => {
            console.error(error);
            return of({});
          }),
          finalize(() => contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = true)
        );
    } else {
      // FI
      obs = this.plycaService
        .query<ContractModificationDTO>(
          this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL,
          {
            dossierId: this.dossierId,
            contractDivision: getSimpleIdentifierFromString(
              contract.division.identifier
            )
            , expand: 'expansionSet:WEB_CLIENT_AYMAD'
          }
        ).pipe(
          tap(contractModifications => {
            let _contractModifications;
            if (contractModifications && contractModifications.content) {
              console.log(
                'INCIDENCIAS DEL CONTRATO ' +
                contract.identifier +
                ' -> ' +
                contractModifications
              );
              _contractModifications = contractModifications.content;
            } else {
              _contractModifications = [];
            }
            contract['EXT_DATA_CONTRACTMODIFICATIONS'] = _contractModifications;
            contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = true;
          }),
          catchError((error: any) => {
            console.error(error);
            return of({});
          }),
          finalize(() => contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = true)
        );
    }
    allQueriesObs.push(obs);

    let params = new HttpParams();
    params = params.append('expand', 'expansionSet:DOCUMENTS_OF_CONTRACT');
    params = params.append('dossierId', this.dossierId);
    params = params.append('division', getSimpleIdentifierFromString(contract.division.identifier));

    let documentClasses = this.appConfig.getValue('contracts.visibleDocuments');
    if (documentClasses) {
      if (documentClasses instanceof Array) {
        documentClasses.forEach(documentClass => params = params.append('documentClasses', documentClass))
      } else {
        params = params.append('documentClasses', documentClasses)
      }

      obs = this.plycaService
        .query<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, params).pipe(
          tap(documents => {
            let docs;
            if (documents && documents.content) {
              console.log(
                'DOCUMENTOS DEL CONTRATO ' +
                contract.identifier +
                ' -> ' +
                documents
              );
              docs = documents.content;
            } else {
              docs = [];
            }
            contract['EXT_DATA_DOCUMENTS'] = docs;
            contract['EXT_DATA_DOCUMENTS_LOADED'] = true;
          }),
          catchError((error: any) => {
            console.error(error);
            return of({});
          }),
          finalize(() => contract['EXT_DATA_DOCUMENTS_LOADED'] = true)
        );
      allQueriesObs.push(obs);
    } else {
      contract['EXT_DATA_DOCUMENTS_LOADED'] = true;

    }
    // }

    let atribShow = 'PROPUESTAID=' + contract.division.project.identifier
      + '&LOTEID=' + getSimpleIdentifierFromString(contract.division.identifier);
    obs = this.plycaService.getAttributeValue(
      'HABILITA_PAGOS_CONT',
      atribShow
    ).pipe(
      tap(x => {
        if (x.values) {
          x.values.forEach(element => {
            if (element.columns['PAGO_HABILITADO'].value) {
              contract['EXT_DATA_SHOW_EXECUTIONPHASES'] = parseInt(element.columns['PAGO_HABILITADO'].value);
            }
          });
        }
      }),
      catchError(err => {
        console.log('Error cargando datos atributo: HABILITA_PAGOS_CONT', err);
        return throwError(err);
      })
    );
    allQueriesObs.push(obs);
    // CARPETAS DE FASE EJECUCION
    allQueriesObs.push(this.loadExecutionDivisionsObs(contract));

    // CONDICIONES ESPECIALES DE EJECUCION
    let atribParams = 'PROPUESTAID=' + contract.division.project.identifier
      + '&DIVISION=' + getSimpleIdentifierFromString(contract.division.identifier);
    obs = this.plycaService.getAttributeValue(
      'SEG_COND_ESP_EJEC_STD',
      atribParams
    ).pipe(
      tap(x => {
        this.specialConditionsReports = [];
        if (x.values) {
          x.values.forEach(element => {
            let report: SpecialCondTracingReportDTO = new SpecialCondTracingReportDTO();
            report.specialConditionIds = element.columns['UUID_COND'].value.split(';');
            if (element.columns['PROX_VENC'].value) {
              report.nextDeadline = moment(element.columns['PROX_VENC'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            }
            if (element.columns['FECHA_EMISION'].value) {
              report.requestDate = moment(element.columns['FECHA_EMISION'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            }
            if (element.columns['FECHA_RESP'].value) {
              report.responseDate = moment(element.columns['FECHA_RESP'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            }
            if (element.columns['VALORACION_MEDIA'].value) {
              report.valorationAverage = +element.columns['VALORACION_MEDIA'].value;
            }
            report.responseInPeriod = element.columns['RESPUESTA_EN_PLAZO'].value;
            if (element.columns['DOC_RESP_UUID'].value) {
              report.responseDoc = new DocumentDTO();
              report.responseDoc.identifier = element.columns['DOC_RESP_UUID'].value;
            }
            if (element.columns['DOC_INF_UUID'].value) {
              report.valorationDoc = new DocumentDTO();
              report.valorationDoc.identifier = element.columns['DOC_INF_UUID'].value;
            }
            this.specialConditionsReports.push(report);
          });
        }

      }),
      catchError(err => {
        console.log('Error cargando datos atributo: SEG_COND_ESP_EJEC_STD', err);
        return throwError(err);
      })
    );
    allQueriesObs.push(obs);
    // Porcentajes de ejecucion (CONTRATO_PORCEN_EJEC_STD)
    let atribParams2 = 'PROPUESTAID=' + contract.division.project.identifier
      + '&DIVISION=' + getSimpleIdentifierFromString(contract.division.identifier);
    obs = this.plycaService.getAttributeValue(
      'CONTRATO_PORCEN_EJEC_STD',
      atribParams2
    ).pipe(
      tap(x => {
        this.executionPercent = 0;
        this.guaranteePercent = 0;
        if (x.values) {
          x.values.forEach(element => {
            if (element.columns['PORCEN_IMP'].value) {
              this.executionPercent = parseInt(element.columns['PORCEN_IMP'].value);
            }
            if (element.columns['PORCEN_PLAZO_GAR'].value) {
              this.guaranteePercent = parseInt(element.columns['PORCEN_PLAZO_GAR'].value);
            }
          });
        }

      }),
      catchError(err => {
        console.log('Error cargando datos atributo: CONTRATO_PORCEN_EJEC_STD', err);
        return of({});
      })
    );
    allQueriesObs.push(obs);
    // SEGUIMIENTO KPIs
    this.kpisRecords = [];
    atribParams = 'PROPUESTAID=' + contract.division.project.identifier + '&DIVISION='
      + getSimpleIdentifierFromString(contract.division.identifier);
    obs = this.plycaService.getAttributeValue(
      'SEGUIMIENTO_KPIS_CONTR_STD',
      atribParams
    ).pipe(
      tap(x => {
        if (x.values) {
          x.values.forEach(element => {
            let record: KpiRecordDTO = new KpiRecordDTO();
            record.date = moment(element.columns['FECHA'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            record.value = +element.columns['VALOR'].value;
            record.kpiId = element.columns['KPI_ID'].value;
            record.kpiDescription = element.columns['KPI_DESC'].value;
            record.levelId = element.columns['NIVEL_ID'].value;
            record.levelDescription = element.columns['NIVEL_DESC'].value;
            this.kpisRecords.push(record);
          });
        }
      }),
      catchError(err => {
        console.log('Error cargando datos atributo: SEGUIMIENTO_KPIS_CONTR_STD', err);
        return of({});
      }),
      finalize(() => {
        this.kpisDateList = this.kpisRecords.map(item => item.date).filter((date, i, self) =>
          self.findIndex(d => d.getTime() === date.getTime()) === i
        ).map(x => {
          let obj = {};
          obj['header'] = moment(x).format('MMM/YYYY');
          obj['date'] = x;
          return obj;
        });
      })
    );
    allQueriesObs.push(obs);

    // Atributos para incidencias: CONF y AADJ firmado. Puede ser diferentes valores por división de contrato.
    // Se almacenan en un hash
    let atribParamsConf = 'PROPUESTAID=' + contract.division.project.identifier
      + '&LOTEID=' + getSimpleIdentifierFromString(contract.division.identifier);
    obs = this.plycaService.getAttributeValue(
      'HAY_CONF',
      atribParamsConf
    ).pipe(
      tap(x => {
        if (x.values) {
          x.values.forEach(element => {
            if (element.columns['CONTR_FIRM'].value) {
              let value = element.columns['CONTR_FIRM'].value === '1';
              let division = getSimpleIdentifierFromString(contract.division.identifier);
              this.signedContracts[division] = value;
            }
          });
        }
      }),
      catchError(err => {
        console.log('Error cargando datos atributo: HAY_CONF', err);
        return of({});
      })
    );
    allQueriesObs.push(obs);

    // Aceptación de la adjudicacion por el Contratista
    let atribParamsAADJ = 'PROPUESTAID=' + contract.division.project.identifier
      + '&LOTEID=' + getSimpleIdentifierFromString(contract.division.identifier);
    obs = this.plycaService.getAttributeValue(
      'HAY_AADJ',
      atribParamsAADJ
    ).pipe(
      tap(x => {
        if (x.values) {
          x.values.forEach(element => {
            if (element.columns['AADJ_FIRM'].value) {
              let value = element.columns['AADJ_FIRM'].value === '1';
              let division = getSimpleIdentifierFromString(contract.division.identifier);
              this.signedAwardAcceptances[division] = value;
            }
          });
        }
      }),
      catchError(err => {
        console.log('Error cargando datos atributo: HAY_AADJ', err);
        return of({});
      })
    );

    allQueriesObs.push(obs);
    return forkJoin(allQueriesObs);
  }

  getSpecialCondReports(specialCondition: ContractSpecialConditionsDTO): SpecialCondTracingReportDTO[] {
    if (this.specialConditionsReports) {
      return this.specialConditionsReports.filter(x => x.specialConditionIds.filter(id => id === specialCondition.identifier).length > 0);
    } else {
      return null;
    }
  }

  getSpecialCondReportStatus(report: SpecialCondTracingReportDTO): string {
    if (report.valorationAverage != null && report.valorationAverage >= 100) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.total')
    } else if (report.valorationAverage != null && report.valorationAverage > 0) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.partial')
    } else if (report.valorationAverage != null && report.valorationAverage == 0) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.noCompliance')
    } else if (report.responseDate != null && !report.valorationDoc) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.pendingAssetment')
    } else if (!report.responseDate) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.pendingSubmit')
    }
  }

  getSpecialCondReportClass(report: SpecialCondTracingReportDTO): string {
    if (report.valorationAverage != null && report.valorationAverage >= 100) {
      return 'text-success'
    } else if (report.valorationAverage != null && report.valorationAverage > 0) {
      return 'text-warning'
    } else if (report.valorationAverage != null && report.valorationAverage == 0) {
      return 'text-danger'
    }
  }

  getSpecialCondReportIcon(report: SpecialCondTracingReportDTO): string {
    if (report.valorationAverage != null && report.valorationAverage >= 100) {
      return 'fa-thumbs-up'
    } else if (report.valorationAverage != null && report.valorationAverage > 0) {
      return 'fa-thumbs-up'
    } else if (report.valorationAverage != null && report.valorationAverage == 0) {
      return 'fa-thumbs-down'
    } else { return 'fa-hourglass-half'; }
  }

  getKpisTypeList(): KpiRecordDTO[] {
    let types: KpiRecordDTO[] = new Array(0);
    this.kpisRecords.forEach(x => {
      if (types.filter(y => y.kpiId === x.kpiId).length == 0) {
        let type: KpiRecordDTO = new KpiRecordDTO();
        type.kpiId = x.kpiId;
        type.kpiDescription = x.kpiDescription;
        types.push(type);
      }
    });
    return types;
  }

  getKpisColumnasFijas(): any[] {
    return [{ 'header': this.translate.instant('Contracts.kpis.type') }];
  }

  getKpiByTypeAndDate(id: string, data: any): KpiRecordDTO {
    let kpi: KpiRecordDTO = this.kpisRecords.find(x => x.kpiId == id && x.date.getTime() === data.date.getTime());
    return kpi ? kpi : new KpiRecordDTO();
  }

  getKpiIcon(id: string, data: any): string {
    let kpi: KpiRecordDTO = this.kpisRecords.find(x => x.kpiId == id && x.date.getTime() === data.date.getTime());
    if (kpi && kpi.levelId == '2') {
      return 'fa-thermometer-empty text-success';
    } else if (kpi && kpi.levelId == '1') {
      return 'fa-thermometer-half text-secondary';
    } else if (kpi && kpi.levelId == '0') {
      return 'fa-thermometer-full text-danger';
    }
    return '';
  }

  private loadExecutionDivisions(contract: ContractDTO): void {
    this.subscribe(this.loadExecutionDivisionsObs(contract));
  }
  private loadExecutionDivisionsObs(contract: ContractDTO): Observable<any> {
    let url = this.configuration.EXECUTION_PHASE_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      this.dossierId
    ).replace(
      '/{divisionId}',
      ''
    );
    return this.plycaService
      .query<ExecutionDivisionDTO>(url, {
        contractId: contract.identifier
      }).pipe(
        tap(executionPhases => {
          let _executionPhases: ExecutionDivisionDTO[];
          if (executionPhases && executionPhases.content) {
            console.log(
              'INCIDENCIAS DEL CONTRATO ' +
              contract.identifier +
              ' -> ' +
              executionPhases
            );
            _executionPhases = executionPhases.content;
          } else {
            _executionPhases = [] as ExecutionDivisionDTO[];
          }
          contract['EXT_DATA_EXECUTIONPHASES'] = _executionPhases;
          contract['EXT_DATA_EXECUTIONPHASES_LOADED'] = true;
        }),
        finalize(() => contract['EXT_DATA_EXECUTIONPHASES_LOADED'] = true)
      );
  }

  viewDocument(doc: DocumentDTO) {
    // this.router.navigate(['documentViewer', document.identifier]);
    let config: DynamicDialogConfig = {
      header: doc.name,
      width: '97%',
      styleClass: 'searchStyle'
    };
    config.data = {
      'id': doc.identifier
    }
    let modal = this.dialogService.open(documentViewerComponent, config);
    this.subscribe(modal.onClose.pipe(
      switchMap(() => this.helpService.showContextHelpObservable(HelpType.DOSSIER_CONTRACTS))));
  }

  openContract(contract: ContractDTO) {
    this.router.navigate(['contracts', contract.identifier]);
  }

  close() { }

  newContract() {
    this.router.navigate(['contracts', 'f35680ad-3da5-4f6c-a013-9b6b8dc5c460']);
  }



  updateExecutionPhase(contract: ContractDTO, executionPhase: ExecutionDivisionDTO) {

    let url = this.configuration.EXECUTION_PHASE_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      executionPhase.project.identifier
    );


    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .update<ExecutionDivisionDTO>(url, executionPhase).pipe(finalize(() => {
        this.waitService.cancelWaiting();
      })).pipe(
        mergeMap(() => this.loadInfoObs()),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      ));
  }
  newExecutionPhase(contract: ContractDTO, name: string) {
    // let url = this.configuration.EXECUTION_PHASE_SERVICE_URL.replace(
    //   '{dossierId}',
    //   this.dossierId
    // ).replace(
    //   '{divisionId}',
    //   getSimpleIdentifierFromString(contract.division.identifier)
    // );
    let url = this.configuration.EXECUTION_PHASE_CONTRACT_SERVICE_URL.replace(
      '{contractId}',
      contract.identifier
    );

    let newExecutionPhase = new ExecutionDivisionDTO();
    newExecutionPhase.name = name;
    newExecutionPhase.parent = contract.division;
    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .insert<ExecutionDivisionDTO>(url, newExecutionPhase).pipe(finalize(() => {
        this.waitService.cancelWaiting();
      })).pipe(
        mergeMap(() => this.loadInfoObs()),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }


  isButtonReopenVisible(executionPhase: ExecutionDivisionDTO) {
    if (!this.isExecutionPhaseClosed(executionPhase)) {
      return false;
    }
    return false;
    // return this.userService.hasRoles('50');

  }

  isExecutionPhaseClosed(executionPhase: ExecutionDivisionDTO) {
    if (executionPhase && executionPhase.phase) {
      return (
        getSimpleIdentifierFromString(executionPhase.phase.identifier) !== '40'
      );
    } else {
      return false;
    }
  }

  public isDefinedInDivisions(contract: ContractDTO, customFieldName: String) {
    if (contract != null && contract['EXT_DATA_EXECUTIONPHASES'] != null) {
      for (let executionPhase of contract['EXT_DATA_EXECUTIONPHASES']) {
        if (this.isDefined(executionPhase, customFieldName)) {
          return true;
        }
      }
    }
    return false;
  }

  public reopenExecutionPhase(contract: ContractDTO, executionPhase: ExecutionDivisionDTO) {
    executionPhase.phase.identifier = '40<>EXPFASE';
    this.updateUserPrefs(contract?.division?.identifier, 1);
    this.updateExecutionPhase(contract, executionPhase);
  }

  public isDefined(executionPhase: ExecutionDivisionDTO, customFieldName: String) {
    return (executionPhase && executionPhase['customFieldDefinitions'] && executionPhase['customFieldDefinitions'][customFieldName]
      !== undefined)
  }

  openExecutionPhaseActions(executionPhase: ExecutionDivisionDTO) {
    let title = 'Acciones de ' + executionPhase.name;
    let contract = this.contractList.find(obj => getSimpleIdentifierFromString(obj.division.identifier)
      == getSimpleIdentifierFromString(executionPhase.parent.identifier));
    if (contract) {
      title = '[' + contract.division.name + '] ' + title;
      this.updateUserPrefs(contract?.division?.identifier, 1);
    }
    let config: DynamicDialogConfig = {
      header: title,
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%', 'min-height': '70vh' },
      styleClass: 'formEdition'
    };
    // config['item'] = new ViewDTOModal(row, 'companyDetailISettings.json');
    // config['esAltaEmpresa'] = esAlta;
    config['dossierId'] = this.dossierId;
    config['divisionId'] = getSimpleIdentifierFromString(
      executionPhase.identifier
    );
    const ref = this.dialogService.open(DossierActionsListComponent, config);
    this.subscribe(ref.onClose, result => {
      // this.loadInfo();
      const event = {
        collapsed: false
      }
      delete contract['loaded']; // para forzar la recarga
      this.loadOneContract(event, contract);
    });
  }

  public editText(contract, executionPhase: ExecutionDivisionDTO) {
    let title = '[' + contract.division.name + '] ' + this.translate.instant('Contracts.ExecutionPhases.edit.title');
    let context = new LongTextDTOModal('', '', false);
    let config: DynamicDialogConfig = {
      header: title,
      width: '50%',
      styleClass: 'formEdition'
    };

    context.label = this.translate.instant('Contracts.ExecutionPhases.edit.fieldname');
    context.text = (executionPhase && executionPhase.name) ? executionPhase.name : '';
    config['context'] = context;

    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose, result => {
      if (result) {

        console.log('ESTABLEDIENDO TEXTO: ');
        console.log(result);
        if (executionPhase) {
          executionPhase.name = result;
          this.updateExecutionPhase(contract, executionPhase)
        } else {
          this.newExecutionPhase(contract, result);
        }

      }
    });
  }

  public buttonDeleteDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO): Observable<any> {
    if (execDivision && execDivision['EXT_DATA_DIV_DElETING'] === true)
      return of('disabled');

    if (execDivision.phase && execDivision.phase.identifier && '40<>EXPFASE' !== execDivision.phase.identifier) {
      return of('disabled');
    }
    return this.buttonsDisabled(contract, execDivision);

  }

  public buttonEditDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO): Observable<any> {
    if (this.isExecutionPhaseClosed(execDivision)) {
      return of('disabled');
    }
    return this.buttonsDisabled(contract, execDivision);

  }

  public buttonOpenActionsDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO): Observable<any> {
    if (execDivision != null &&
      execDivision?.executionStatus === 'PAUSED') {
      if (!this.userService.hasRoles('29', this.project.documentClass.application)) {
        return of('disabled');
      }

    }
    return this.buttonsDisabled(contract, execDivision, false);

  }

  public buttonsDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO, checkState = true): Observable<any> {

    // Si la fase de ejecucion no esta en ejecucion tampoco
    if (checkState) {
      if (execDivision != null &&
        execDivision?.executionStatus !== 'RUNNING' &&
        execDivision?.executionStatus !== 'CLOSED') {
        return of('disabled');
      }
    }


    // Y si el expediente esta en modo soporte y nuestro usuario no esta permitido tampoco
    if (!this.project.userAllowedForSupport) {
      return of('disabled');
    }

    // Los acuerdos marcos no lo permiten
    if (this.project?.classification?.complementarySystem?.identifier == 'AM<>SISTCOMPLEMENTARIO') {
      return of('disabled');
    }


    // Revisamos los perfiles DEL APLICATIVO de ese expediente
    let profiles = this.appConfig.getValue('contracts.perfilVerBotonPagos'); // En el applet se gestiona con la propiedad 'FraSelExpediente.perfilVerBotonPagos'

    let isProfileAllowed = true;
    let isSituationAllowed = true;
    let isStateAllowed = true;
    let isFillingStateAllowed = true;

    if (profiles != null && profiles != undefined) {
      isProfileAllowed = this.userService.hasRoles(profiles, this.project.documentClass.application);
    }

    // Y si esta archivado
    let fillingState: string = this.project.status.filingState;
    if (fillingState != null && fillingState != undefined) {
      isFillingStateAllowed = fillingState === 'NotFiled';
    }

    if (isFillingStateAllowed) {

      // Y la situacion
      let stSituations = this.propertyService.instant('FraSelExpediente.situacionOcultaBotonPagos');

      if (stSituations != null && stSituations != undefined) {
        let projectSituation = this.project.status.situation;
        let situations = stSituations.split(';');
        let situationDefinitions = Object.values(DossierSituation);
        situations.forEach(stSituation => {
          let intSituation = +stSituation;
          let situation = situationDefinitions[intSituation];
          if (situation === projectSituation) {
            isSituationAllowed = false;
          }
        });

      }

      if (isSituationAllowed) {
        // Y los estados
        let stStates = this.propertyService.instant('FraSelExpediente.estadosOcultaBotonPagos');
        let projectState = this.project.status.state.identifier;
        if (stStates != null && stStates != undefined) {
          let states = stStates.split(';');
          states.forEach(state => {
            let normalizedState = state + '<>EXPESTADO';
            if (normalizedState == projectState) {
              isStateAllowed = false;
            }
          });
        }
      }
    }

    return of(isProfileAllowed && isFillingStateAllowed && isSituationAllowed && isStateAllowed ? null : 'disabled');
  }


  deleteExecutionDivision(contract: ContractDTO, execDivision?: ExecutionDivisionDTO) {

    this.uiService.showConfirmMessage({
      message: '¿Está seguro de borrar la carpeta "' + execDivision.name + '"?',
      header: this.translate.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.doDeleteExecutionDivision(contract, execDivision)
    });
  }

  doDeleteExecutionDivision(contract: ContractDTO, execDivision?: ExecutionDivisionDTO) {
    if (execDivision) {
      if (execDivision['EXT_DATA_DIV_DElETING'] == true)
        return;
      execDivision['EXT_DATA_DIV_DElETING'] = true;
    }
    this.subscribe(
      this.plycaService.runActionByName('DELETE_EXECUTION_DIVISION', 'TARGET=' + execDivision.identifier),
      (result: ActionResultDTO) => {
        console.log(result);
        if (result && result.identifier === 'OK') {
          this.updateUserPrefs(contract?.division?.identifier, 1);
          this.loadExecutionDivisions(contract);
        } else {
          let isWarning = result.validationResult != null && result.validationResult.result === ResultTypeDTO.WARNING;
          this.uiService.showMessage(this.translate.instant(result.description), this.translate.instant(isWarning ? 'General.warning' : 'General.error'));
        }
        if (execDivision) {
          execDivision['EXT_DATA_DIV_DElETING'] = false;
        }
      },
      () => {
        this.plycaErrorHandler.showServerError(
          this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.supportEventCreateProcessResultError')
        );
        if (execDivision) {
          execDivision['EXT_DATA_DIV_DElETING'] == false;
        }
      }

    );
  }

  editExecutionDivision(contract: ContractDTO, execDivision?: ExecutionDivisionDTO) {
    let title = '[' + contract.division.name + '] ' + this.translate.instant('Contracts.ExecutionPhases.edit.title');
    let config: DynamicDialogConfig = {
      header: title,
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'
    };
    config['contract'] = contract;
    config['prefixName'] = 'Certificación ';
    this.updateUserPrefs(contract?.division?.identifier, 1);
    if (execDivision) {
      config['id'] = execDivision.identifier;
    }

    const ref = this.dialogService.open(
      ExecutionDivisionEditionComponent,
      config
    );

    ref.onClose.pipe(take(1)).subscribe(result => {
      this.loadExecutionDivisions(contract);
    });
  }


  public viewText(executionPhase: ExecutionDivisionDTO) {
    let context = new LongTextDTOModal('', '', true

    );


    let config: DynamicDialogConfig = {
      header: '',
      width: '50%',


      styleClass: 'searchStyle'
    };

    context.label = this.translate.instant('Contracts.ExecutionPhases.edit.name');
    context.text = executionPhase.name;
    config['context'] = context;



    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose);
  }
  public isInitialPhase(contract: ContractDTO) {
    let result = false;
    if (contract.division.project.phase.identifier === '0<>EXPFASE') {
      result = true;
    }
    return result;
  }

  isContractExecutionEnabled(contract: ContractDTO) {
    try {
      let contractExecutionEnabled = this.appConfig.getValueByDossierType(this.project.documentClass.application, 'contractExecution.enabled');
      if (contractExecutionEnabled == undefined) {
        contractExecutionEnabled = this.appConfig.getValue('contractExecution.enabled');
      }

      return contractExecutionEnabled;
    } catch { }
    return true;
  }

  isExecutionDivisionVisible(contract: ContractDTO) {
    return contract['EXT_DATA_SHOW_EXECUTIONPHASES'] == 1;
  }

  isExecutionMonitoringModuleEnabled() {
    return this.userService.hasModulesAccess(["SEGCON"]);
  }




  public getFirmantes(doc: DocumentDTO) {
    if (doc && doc.currentVersion && doc.currentVersion.signers) {
      return doc.currentVersion.signers.map(e => e.name).join(', ');
    }
    return '';
  }


  getSimpleIdentifierFromString(division: DivisionDTO) {
    return getSimpleIdentifierFromString(division.identifier);
  }

  showExecutionDivisionDocuments(executionDivision: any) {

    if (this.project.identifier) {
      let contractName = this.getContractName(executionDivision);
      if (contractName == null) {
        contractName = this.project.contractFolderId + (this.project.abbreviatedTitle !== undefined ? ': ' + this.project.abbreviatedTitle : '');
      } else {
        contractName = '[' + contractName + ']';
      }
      let title =
        contractName +
        ' ' + executionDivision.name;
      let filters = {
        avoidTemporaryDocs: false,
        division: getSimpleIdentifierFromString(executionDivision)
      }
      this.documentService.openDossierDocumentsDialog(this.project.identifier, title, filters);
    }
  }

  getContractName(executionDivision: any) {
    let contractName = null;
    if (this.contractList && executionDivision.parent) {
      let contractDiv = getSimpleIdentifierFromString(executionDivision.parent.identifier);
      this.contractList.forEach(con => {

        if (con.division) {
          let conDivId = getSimpleIdentifierFromString(con.division.identifier);
          if (conDivId == contractDiv && con.division.name)
            contractName = con.division.name;
        }
      });
    }
    return contractName;
  }

  removeTime(dateTimeString: string): string {
    // Verifica si el string no es nulo o indefinido
    if (!dateTimeString) {
      return dateTimeString
    }
    // Busca la fecha en el formato esperado y elimina la parte de la hora
    const datePattern = /\d{2}-\d{2}-\d{4}/;
    const match = dateTimeString.match(datePattern);

    // Si encuentra un match, devuelve solo la parte de la fecha
    if (match && match.index) {
      return dateTimeString.substring(0, match.index + match[0].length);
    }

    // Si no encuentra un match, devuelve el string original
    return dateTimeString;
  }

  // *******************
  // METODOS INCIDENCIAS
  // *******************

  // Visibilidad del Área de Incidencias:
  // - Si es registro de contratos, comprobamos si las FRCFI están o no disponibles para expedientes de tipo 600.
  // - Si no lo es, comprobamos si las FI están o no disponibles.
  isNewContractModificationVisible() {
    if (this.project.documentClass.identifier === '00600') {
      return this.newRegisterContractModificationVisible;
    } else {
      // Se ocultan para version normativa 02.
      let validApplicableLegislation = false;
      if (this.project !== undefined && this.project.applicableLegislation !== undefined
        && this.project.applicableLegislation.identifier !== undefined) {
        let applicableLegislation = this.project.applicableLegislation.identifier;
        let applicableLegislationIdentifier: string = applicableLegislation.substring(0, applicableLegislation.indexOf('<>'));
        validApplicableLegislation = (parseInt(applicableLegislationIdentifier, 10) > 2);
      }
      return validApplicableLegislation && this.newContractModificationVisible;
    }
  }

  // Comprueba si el tipo de contrato permite crear o no incidencias. Se aplica en expedientes de Contratación
  contractAvailableForContractModification(contract: ContractDTO): boolean {
    // PERMITIR_INCIDENCIAS
    let available = true;
    if (contract.procurementProjectInfo !== undefined && contract.procurementProjectInfo.type !== undefined
      && contract.procurementProjectInfo.type.identifier !== undefined) {
        // La propiedad define los tipos de contratos en los que NO se pueden crear incidencias.
      let property = this.propertyService.instant('PERMITIR_INCIDENCIAS');
      if (property) {
        // Dividir el string de identificadores en un array
        const contractTypeIdentifiers = property.split(';');
        const contractType = getSimpleIdentifierFromString(contract.procurementProjectInfo.type.identifier);
        // Verificar si alguno de los identificadores coincide con el identifier de contract
        available = !contractTypeIdentifiers.includes(contractType);
      }
    }
    return available;
  }

  // Comprueba si el tiene documento contrato firmado.
  signedContract(contract: ContractDTO) {
    let division = getSimpleIdentifierFromString(contract.division.identifier)
    if (this.signedContracts[division] !== undefined) {
      return this.signedContracts[division];
    } else {
      return false;
    }
  }

  // Comprueba si el contrato tiene Aceptación de la Adjudicación por el contratista
  signedAwardAcceptance(contract: ContractDTO) {
      let division = getSimpleIdentifierFromString(contract.division.identifier)
      if (this.signedAwardAcceptance[division] !== undefined) {
        return this.signedAwardAcceptance[division];
      } else {
        return false;
      }
  }

  // Metodo que comprueba si es posible crear incidencias.
  // Si es un expediente de REPLYCA, devuelve true.
  // Si es expediente de Contratación, comprueba si existen documentos necesarios.
  // Si devuelve FALSE, muestra un panel indicando el mensaje correspondiente.
  canCreateNewContractModifications(contract: ContractDTO) {
    if (this.project && this.project.documentClass.identifier !== '00600') {
      // Los basados no comprueban documentos firmados.
      let isBasedContract = this.project?.classification !== undefined && this.project.classification.complementarySystem !== undefined
        && this.project.classification.complementarySystem.identifier !== undefined
        && this.project.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

      let signedContract = this.signedContract(contract);
      let signedAwardAcceptance = this.signedAwardAcceptance(contract);
      let isASA = false;

      if (this.project !== undefined && this.project.type !== undefined && this.project.type.identifier !== undefined
        && this.project.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA') {
          isASA = true;
        }

      // Si es ASA, tiene que existir uno de los documentos firmados.
      let signedDocuments = isASA ? (signedContract || signedAwardAcceptance) : (!isBasedContract ? signedContract : true);
      let contractAvailableForContractModification = this.contractAvailableForContractModification(contract);
      return signedDocuments && contractAvailableForContractModification;
    } else {
      return true;
    }
  }

  // Método que devuelve el mensaje que se muestra si no es posible crear incidencias.
  contractModificationNoAvailableText(contract: ContractDTO) {
    let text = 'No se permiten crear incidencias para contratos sin firmar';
    if (this.project !== undefined && this.project.type !== undefined && this.project.type.identifier !== undefined
      && this.project.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA') {
      text = text + ' o sin la Aceptación de la Adjudicación por el Contratista.';
    } else {
      let contractNotAvailable = !this.contractAvailableForContractModification(contract)
      if (contractNotAvailable) {
        text = 'No se pueden crear incidencias para este tipo de contrato';
      }
    }
    return text;
  }

  isContractModificationVisible(contract: ContractDTO) {
    if (contract.division && contract.division.project && contract.division.project.documentClass.identifier === '00600') {
      return false;
    } else {
      return true;
    }
  }

  // Incidencias habilitadas en web.
  // Las que no lo están no pueden visualizarse en modo solo lectura.
  contractModificationWebAvailable(contractModification?: any) {
    let readOnlyAvailable =  false;
    if (contractModification.alias !== undefined) {
      readOnlyAvailable =  ('PM' !== contractModification.alias ||
        'ACT' !== contractModification.alias ||
        'AJP' === contractModification.alias)
    }
    return readOnlyAvailable;
  }

  openContractModificationReadOnly(contractModification?: any) {
    if (contractModification) {
      this.router.navigate(['aymadcontractModifications', contractModification.identifier], {
        queryParams: { readOnly: 'true' }
      });
    }
  }

  openContractModification(contractModification?: any) {
    if (contractModification) {
      this.router.navigate(['aymadcontractModifications', contractModification.identifier], {
        queryParams: {}
      });
    }
  }

  absoluteValue(value: number): number {
    return Math.abs(value);
  }

  private getEnabledSituationClass(): boolean {
    let enabled = true;
    if (this.project) {
      switch (this.project.status.situation) {
        case 'Extinguished': { // Extingido
          enabled = false;
          break;
        }
        case 'Cancelled': { // Cancelado
          enabled = false;
          break;
        }
        case 'Support': { // Modo soporte
          enabled = false;
          break;
        }
      }
    }
    return enabled;
  }

  // Método que deshabilita el botón de creación de nuevas incidencias.
  disabledButtonNewContractModification(contract: ContractDTO) {
    let situationEnabled = this.getEnabledSituationClass();
    let faseEnabled = true;
    if (this.project && this.project.documentClass.identifier !== '00600') {
      faseEnabled = this.project.phase.identifier !== '0<>EXPFASE' && this.project.phase.identifier !== '50<>EXPFASE';
      let signedContract = false;
      let signedAwardAcceptance = false;
      let isBasedContract = this.project?.classification !== undefined && this.project.classification.complementarySystem !== undefined
        && this.project.classification.complementarySystem.identifier !== undefined
        && this.project.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
      // Los basados no comprueban documentos firmados.
       if (situationEnabled && faseEnabled && !isBasedContract) {
        let division = getSimpleIdentifierFromString(contract.division.identifier)
        if (this.signedContracts[division] !== undefined) {
          signedContract = this.signedContracts[division];
        }
        if (this.project !== undefined && this.project.type !== undefined && this.project.type.identifier !== undefined
          && this.project.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA') {
          // COGER LA DIVISION.
          if (this.signedAwardAcceptances[division] !== undefined) {
            signedAwardAcceptance = this.signedAwardAcceptances[division];
          }
          // signedAwardAcceptances
          return signedContract || signedAwardAcceptance;
        } else {
          return signedContract;
        }
      } else {
        // Comprobamos primero que el expediente sea o no de obras.
        let isWorks = false;
        if (this.project?.classification?.typeCode !== undefined) {
          isWorks = this.project?.classification?.typeCode.identifier === '01<>TIPOEXPTE';
        }
        if (isWorks) {
          // Se pueden crear incidencias en expedietnes de obras en fase de extinción.No comprueba la fase 50.
          return situationEnabled && this.project.phase.identifier !== '0<>EXPFASE';
        } else {
          return situationEnabled && faseEnabled;
        }
       }
    } else {
      return (situationEnabled && faseEnabled);
    }
  }

  // Acción del botón de Creación de nuevas incidencias.
  createNewContractModification(contract: ContractDTO, contractModification?: any) {
    if (contract.division && contract.division.project && contract.division.project.documentClass.identifier === '00600') {
      // FRCFI
      if (contractModification) {
        this.router.navigate([
          'registerContractModifications',
          contractModification.identifier
        ]);
      } else {
        this.subscribe(this.openActiveContractModificationsList(contract).onClose, result => {
          if (result) {
            this.router.navigate(['registerContractModifications', 'new'], {
              queryParams: {
                projectIdentifier: this.dossierId,
                contractDivision: getSimpleIdentifierFromString(
                  contract.division.identifier
                ),
                type: result,
                contractId: contract.identifier
              }
            });
          }
        });
      }
    } else {
      // FI
      if (contractModification) {
        this.router.navigate([
          'aymadcontractModifications',
          contractModification.identifier
        ]);
      } else {
        this.subscribe(this.openActiveContractModificationsList(contract).onClose, result => {
          if (result) {
            this.router.navigate(['aymadcontractModifications', 'new'], {
              queryParams: {
                projectIdentifier: this.dossierId,
                contractDivision: getSimpleIdentifierFromString(
                  contract.division.identifier
                ),
                type: result,
              }
            });
          }
        });
      }
    }
  }

  // Método que abre el listado de incidencias, tanto de REPLYCA como de CONTRATACION
  openActiveContractModificationsList(contract: ContractDTO) {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('ContractModification.new'),
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '70%' },
      styleClass: 'searchStyle'
    };
    config['contractId'] = contract.identifier;

    if (contract.division && contract.division.project && contract.division.project.documentClass.identifier === '00600') {
      config['isProjectReplyca'] = contract.division.project.documentClass.identifier === '00600';
    } else {
      config['isProjectReplyca'] = false;
    }
    return this.dialogService.open(contractModificationTypesComponent, config);
  }

  // Comprueba si pueden consultarse o no los antecedentes
  viewAntecedentes() {
    if (this.project.documentClass.identifier === '00600') {
      return false;
    } else {
      // Se ocultan para version normativa 02.
      let validApplicableLegislation = false;
      if (this.project !== undefined && this.project.applicableLegislation !== undefined
        && this.project.applicableLegislation.identifier !== undefined) {
        let applicableLegislation = this.project.applicableLegislation.identifier;
        let applicableLegislationIdentifier: string = applicableLegislation.substring(0, applicableLegislation.indexOf('<>'));
        validApplicableLegislation = (parseInt(applicableLegislationIdentifier, 10) > 2);
      }
      return validApplicableLegislation;
    }
  }

  // Método que abre los antecedentes de una incidencia
  openContractModificationAntecedent(contract: ContractDTO, contractModification?: any, antecedentMode = '') {
    antecedentMode = 'contractModification'
    let config: DynamicDialogConfig = {
      header: 'Antecedentes de la incidencia',
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    contractModification.contract = contract;
    context['contractModification'] = contractModification;
    context['dossierId'] = this.dossierId;
    config['context'] = context;


    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(AntecedentAYMADComponent, config).onClose,
      (antecedent: boolean) => {
      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }


}
